<template>
  <div style="display: contents" v-if="getAllowedCookiePolicy !== 'allowed'">
    <div class="cookie-modal-overlay"></div>
    <div class="cookie-modal">
      <div class="cookie-modal__header">
        <span>YOUR POLICY</span><fa-icon :icon="['fas', 'lock']" />
      </div>
      <div class="cookie-modal__wrapper">
        <div class="cookie-modal__body">
          <span>
            By continuing the use of our Website, you are explicitly and actively
            consenting to our processing of your personal information as per our <a @click="$router.push('privacy-policy')">Privacy Policy</a>.
          </span>
        </div>
        <div class="cookie-modal__submit">
          <button class="button is-primary" @click="acceptCookie">ACCEPT</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showCookieModal: false
    };
  },
  computed: {
    getAllowedCookiePolicy() {
      return this.$store.getters.getAllowedCookiePolicy;
    }
  },
  methods: {
    acceptCookie() {
      this.$store.commit('setAllowedCookiePolicy');
    }
  },
};
</script>
<style lang="scss">
  .cookie-modal-overlay {
    height: 100vh;
    width: 100vw;
    background: rgba(0,0,0,0.50);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 18;
  }
  .cookie-modal {
    width: 100%;
    background: #dfdfdf;
    position: sticky;
    z-index: 19;
    padding: 15px;
    bottom:0;
    top: 0;
    left: 0;
    &__body {
      text-align: start;
      margin-left: 25px;
      margin-bottom: 25px;
      font-weight: normal;
      font-size: 13px;
    }
    &__header {
      text-align: start;
      margin-left: 25px;
      margin-bottom: 17px;
      font-size: 18px;
      & span {
        margin-right: 8px;
      }
    }
    &__submit {
      & button {
        width: 80%!important;
        padding: 20px;
        font-size: 16px;
      }
    }
  }
  @media(min-width: 1366px) {
    .cookie-modal {
      &__wrapper {
        display: flex;
      }
      &__body {
        width: 100%;
      }
      &__submit {
        width: 50%;
      }
    }
  }
  @media(max-width: 768px) {
    .cookie-modal {
      &__container {
        bottom: -26px;
      }
      &__body {
       // text-align: center;
       // margin-left: unset;
      }
    }
  }
</style>